(() => {
  if (window.sanearKitCartLoaded) return;
  window.sanearKitCartLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  const pending = new WeakSet();
  document.addEventListener('click', (event) => {
    const path = event.composedPath();
    const kitButton = path.find(node => node.classList?.contains('cartmax-card-content-right-button'));
    if (kitButton) {
      const host = path.find(node => node.tagName === 'CARTMAX-PRODUCT-RECOMMEND');
      const config = host?.ProductStore?.getData?.(1);
      if (config?.rules?.settings?.checkout_btn_type === 2) config.rules.settings.add_to_cart_button_redirect = 2;
    }
    const reviewButton = path.find(node => node.matches?.('[data-sanear-review-cart]'));
    const accelerated = path.find(node => node.classList?.contains('shopify-payment-button'));
    if (!reviewButton && !accelerated) return;
    const form = (reviewButton || accelerated).closest('form');
    const primary = form?.querySelector('[name="add"]');
    if (!form || !primary) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending.has(form) || primary.disabled || primary.getAttribute('aria-disabled') === 'true' || !form.reportValidity()) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    const button = form.querySelector('[data-sanear-review-cart]');
    pending.add(form);
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    const cleanup = () => {
      pending.delete(form);
      document.removeEventListener('product-ajax:added', afterAdd);
      document.removeEventListener('product-ajax:error', cleanup);
      clearTimeout(timer);
      if (button) { button.disabled = primary.disabled; button.removeAttribute('aria-busy'); }
    };
    const afterAdd = (addedEvent) => {
      const product = addedEvent.detail?.product;
      if (String(product?.variant_id || product?.id) !== variantId) return;
      cleanup();
      window.location.assign(root + 'checkout');
    };
    document.addEventListener('product-ajax:added', afterAdd);
    document.addEventListener('product-ajax:error', cleanup, { once: true });
    const timer = setTimeout(cleanup, 30000);
    primary.click();
  }, true);
})();
